var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagElSalvador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.0107422C9.65689 0.0107422 4.17589 3.7023 1.58789 9.05424H30.4126C27.8246 3.7023 22.3436 0.0107422 16.0003 0.0107422Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.0108C22.3436 32.0108 27.8246 28.3192 30.4126 22.9673H1.58789C4.17589 28.3192 9.65689 32.0108 16.0003 32.0108Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7869 16.7063L16 11.1411L19.2131 16.7063H12.7869Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 18.544L16 20.631L11.826 18.544V15.7615H20.1739V18.544Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9349 11.3799L18.4592 12.8556C19.0886 13.485 19.478 14.3546 19.478 15.3151C19.478 17.2361 17.9207 18.7933 15.9998 18.7933C14.0788 18.7933 12.5215 17.236 12.5215 15.3151C12.5215 14.3546 12.9109 13.485 13.5403 12.8556L12.0646 11.3799C11.0574 12.3869 10.4346 13.7782 10.4346 15.3151C10.4346 18.3887 12.9262 20.8803 15.9998 20.8803C19.0733 20.8803 21.5649 18.3886 21.5649 15.3151C21.5649 13.7782 20.942 12.3869 19.9349 11.3799Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagElSalvador);
export default __webpack_public_path__ + "static/media/flag_el_salvador.c35c1e079f91b533846aa6a98d5c37d7.svg";
export { ForwardRef as ReactComponent };